import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';

import { handleApiRequest } from '../../api';

import useApiError from '../../hook/useApiError';
import useGlobalStatus from '../../hook/useGlobalStatus';

import Loading from '../../components/loading/Loading';
import AlertMsg from '../../components/alert/AlertMsg';
import NormalTable from '../../components/table/NormalTable';
import { tableColumnsDefined } from '../../components/table/tableDefined';
import { handleTableQuery } from '../../components/table/tableQuery';

import { PAGE } from '../../constants/url';

import { formatDate2 } from '../../utils/date';

import { TEST_USER } from './constants';

import { ALERT_TYPE, SUCCESS_AI_BLOCKED_OPEN, SUCCESS_CHANGE_AI_CLOSE } from '../../constants/alertMsg';


const UserList = ({
  searchKeyword,
  userList,
  sortUserList,
  setSortUserList,
  getUserList,
  isLoading,
  setIsLoading
}) => {
  const { handleApiErrorStatus } = useApiError();
  const { handleAlertMsgSettings } = useGlobalStatus();
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const currentTableColumnsDefined = tableColumnsDefined['userList'];

  const handleAiBlocked = (checked, data) => {
    setIsLoading(true);

    const parameters = new URLSearchParams({
      identity: data.identity,
      messaging_status_ai_blocked: checked
    })

    handleApiRequest('putUserAiBlocked', parameters)
      .then(res => {
        if (res.status === 200) {
          handleAlertMsgSettings(true, {
            type: ALERT_TYPE.SUCCESS,
            msg: checked === false ? SUCCESS_AI_BLOCKED_OPEN : SUCCESS_CHANGE_AI_CLOSE
          });
          getUserList();
        } else {
          handleApiErrorStatus();
        }
      })
  }

  const handleTableAction = (e, { id, data }) => {
    if (id === 'messaging_status_ai_blocked') {
      handleAiBlocked(!e.target.checked, data);
    }
  }

  const handleSettings = ({ component, condition }) => {
    if (component === 'table') {
      const updateData = handleTableQuery(userList, condition);
      setSortUserList(updateData);
    }
  }

  // console.log('userList', userList);

  return (
    <>
      {
        !isLoading &&
        <NormalTable
          userAuth={{ role: 'admin' }}
          size='small'
          tableColumnsDefined={currentTableColumnsDefined}
          tableData={{
            page: { size_total: userList.length },
            data: sortUserList
          }}
          handleSettings={handleSettings}
          handleTableAction={handleTableAction}
          searchKeyword={searchKeyword}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          page={page}
          setPage={setPage}
        />
      }
    </>
  )
}

export default UserList;